import React, { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { notificationAPI } from '../services/api';
import toast from 'react-hot-toast';
import { BASE_URL } from '../config';

const NotificationBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount,   setUnreadCount]   = useState(0);
  const [open,          setOpen]          = useState(false);
  const [loading,       setLoading]       = useState(false);
  const socketRef = useRef(null);

  const load = async () => {
    try {
      const res = await notificationAPI.getAll();
      setNotifications(res.data.notifications);
      setUnreadCount(res.data.unreadCount);
    } catch (err) {
      console.error('Notifications load nahi hue');
    }
  };

  useEffect(() => {
    load();

    // Socket.io connection
    const user = JSON.parse(localStorage.getItem('bhamsa_user') || '{}');
    if (user.id) {
      const socket = io(BASE_URL);
      socketRef.current = socket;

      // Apna user_id register karo
      socket.on('connect', () => {
        console.log('🔌 Socket connected!');
        socket.emit('register', user.id);
      });

      // Nai notification aane par
      socket.on('new_notification', (notification) => {
        console.log('🔔 New notification received!', notification);
        
        // List mein add karo
        setNotifications(prev => [notification, ...prev]);
        setUnreadCount(prev => prev + 1);

        // Toast show karo
        toast(
          `🔔 ${notification.title}\n${notification.message}`,
          {
            duration: 5000,
            style: {
              background: 'var(--bg2)',
              color: 'var(--text)',
              border: '2px solid var(--accent)',
              borderRadius: '10px',
              fontSize: '13px',
              maxWidth: '350px',
            },
          }
        );
      });

      socket.on('disconnect', () => {
        console.log('❌ Socket disconnected');
      });

      return () => {
        socket.disconnect();
      };
    }
  }, []);

  const handleMarkRead = async (id) => {
    try {
      await notificationAPI.markRead(id);
      setNotifications(notifications.map(n =>
        n.id === id ? { ...n, is_read: true } : n
      ));
      setUnreadCount(prev => Math.max(0, prev - 1));
    } catch (err) {
      console.error('Mark read failed');
    }
  };

  const handleMarkAllRead = async () => {
    setLoading(true);
    try {
      await notificationAPI.markAllRead();
      setNotifications(notifications.map(n => ({ ...n, is_read: true })));
      setUnreadCount(0);
      toast.success('Saari notifications read ho gayi!');
    } catch (err) {
      toast.error('Error aaya');
    } finally { setLoading(false); }
  };

  const typeIcon = (type) => {
    if (type === 'plan_purchase')        return '🎉';
    if (type === 'plan_expiry_reminder') return '⚠️';
    if (type === 'plan_expired')         return '❌';
    return '📢';
  };

  return (
    <>
      {/* Bell Icon */}
      <div style={{ position: 'relative' }}>
        <div
          onClick={() => setOpen(!open)}
          style={{
            width: 38, height: 38, borderRadius: '50%',
            background: 'var(--bg3)',
            border: `1px solid ${unreadCount > 0 ? 'var(--accent)' : 'var(--border)'}`,
            display: 'flex', alignItems: 'center',
            justifyContent: 'center', cursor: 'pointer',
            fontSize: 18, position: 'relative',
            transition: 'all 0.2s',
            animation: unreadCount > 0 ? 'bellShake 1s ease infinite' : 'none',
          }}
        >
          🔔
          {unreadCount > 0 && (
            <div style={{
              position: 'absolute', top: -4, right: -4,
              background: 'var(--danger)', color: '#fff',
              borderRadius: '50%', width: 18, height: 18,
              fontSize: 10, fontWeight: 700,
              display: 'flex', alignItems: 'center',
              justifyContent: 'center',
            }}>
              {unreadCount > 9 ? '9+' : unreadCount}
            </div>
          )}
        </div>

        {/* Dropdown */}
        {open && (
          <div style={{
            position: 'absolute', top: '100%', right: 0,
            marginTop: 8, background: 'var(--bg2)',
            border: '1px solid var(--border)', borderRadius: 12,
            width: 340, maxHeight: 420, overflow: 'hidden',
            zIndex: 100, boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
          }}>
            {/* Header */}
            <div style={{
              padding: '14px 16px',
              borderBottom: '1px solid var(--border)',
              display: 'flex', alignItems: 'center',
              justifyContent: 'space-between',
              background: 'var(--bg3)',
            }}>
              <div style={{ fontWeight: 600, fontSize: 14 }}>
                🔔 Notifications
                {unreadCount > 0 && (
                  <span style={{
                    marginLeft: 8, background: 'var(--danger)',
                    color: '#fff', borderRadius: 20,
                    padding: '2px 8px', fontSize: 11,
                  }}>
                    {unreadCount} new
                  </span>
                )}
              </div>
              {unreadCount > 0 && (
                <button
                  className="btn btn-ghost btn-sm"
                  onClick={handleMarkAllRead}
                  disabled={loading}
                  style={{ fontSize: 11 }}
                >
                  ✓ Sab Read Karo
                </button>
              )}
            </div>

            {/* List */}
            <div style={{ overflowY: 'auto', maxHeight: 340 }}>
              {notifications.length === 0 ? (
                <div style={{
                  padding: 32, textAlign: 'center',
                  color: 'var(--text3)', fontSize: 13,
                }}>
                  <div style={{ fontSize: 32, marginBottom: 8 }}>🔔</div>
                  Koi notifications nahi
                </div>
              ) : (
                notifications.map(n => (
                  <div
                    key={n.id}
                    onClick={() => !n.is_read && handleMarkRead(n.id)}
                    style={{
                      padding: '12px 16px',
                      borderBottom: '1px solid var(--border)',
                      background: n.is_read ? 'transparent' : 'rgba(108,99,255,0.06)',
                      cursor: n.is_read ? 'default' : 'pointer',
                      transition: 'background 0.2s',
                    }}
                  >
                    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                      <span style={{ fontSize: 18, flexShrink: 0 }}>
                        {typeIcon(n.type)}
                      </span>
                      <div style={{ flex: 1 }}>
                        <div style={{
                          fontSize: 13,
                          fontWeight: n.is_read ? 400 : 600,
                          color: n.is_read ? 'var(--text2)' : 'var(--text)',
                          marginBottom: 4,
                        }}>
                          {n.title}
                        </div>
                        <div style={{
                          fontSize: 12, color: 'var(--text3)', lineHeight: 1.5,
                        }}>
                          {n.message}
                        </div>
                        <div style={{
                          fontSize: 11, color: 'var(--text3)', marginTop: 6,
                        }}>
                          {new Date(n.createdAt).toLocaleDateString('en-IN', {
                            day: 'numeric', month: 'short',
                            hour: '2-digit', minute: '2-digit',
                          })}
                          {!n.is_read && (
                            <span style={{
                              marginLeft: 8, color: 'var(--accent)', fontSize: 10,
                            }}>
                              ● New
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>

      {/* Bell shake animation */}
      <style>{`
        @keyframes bellShake {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-10deg); }
          75% { transform: rotate(10deg); }
        }
      `}</style>

      {/* Backdrop */}
      {open && (
        <div
          style={{ position: 'fixed', inset: 0, zIndex: 99 }}
          onClick={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default NotificationBell;